if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }
    
    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}
/*
 *  Project: OB - WavWay
 *  Date: January 16, 2017
 *  Author: Office/Bureau
 *  Version: 1.0
 */
;
(function($, window, document, google, obMapMarker, undefined) {

  var pluginName = 'obWavWay',
    defaults = {};

  function Plugin(element, options) {
    this.$element = $(element);
    this.$map = this.$element.find('#ob-map');
    this.apiBase = wp.rest_url + 'ob/v1/';
    this.$address = this.$element.find('.directions__waypoint input');
    this.$suggestions = this.$element.find('.directions__suggestions');
    this.$trackList = $('#ob-tracks');
    this.$button = this.$element.find("#ob-button");
    this.$playlist = this.$element.find(".playlist");
    this.$playlist__departure = this.$element.find('.playlist__waypoint--departure');
    this.$playlist__destination = this.$element.find('.playlist__waypoint--destination');
    this.$playlist__link = this.$playlist.find('.playlist__link');
    this.$share__link_twitter = this.$playlist.find('.icon--twitter');
    this.$share__link_facebook = this.$playlist.find('.icon--facebook');
    this.$playlist__links = this.$playlist.find('.playlist__links');
    this.departure = this.$map.data('departure') ? this.$map.data('departure') : false;
    this.departure_label = false;
    this.destination = this.$map.data('destination') ? this.$map.data('destination') : false;
    this.destination_label = false;
    this.latitude = 49.2977073;
    this.longitude = -82.7457681;
    this.is_permalink = false;
    this.autocompleteService = new google.maps.places.AutocompleteService();
    this.directionsService = new google.maps.DirectionsService();
    this.directionsDisplay = new google.maps.DirectionsRenderer({
      polylineOptions: {
        strokeColor: "#A7262D"
      },
      suppressMarkers: true,
    });
    this.markers = [];
    this.infoWindows = [];
    this.nonce = wp.nonce;

    this._defaults = defaults;
    this._name = pluginName;

    this.init();
  }

  Plugin.prototype = {
    init: function() {
      this.setListeners();
      this.renderMap();
      //If we're on a permalink page, render the map
      if( this.destination && this.departure ){
        this.is_permalink = true;
        this.getDirections();
      }
    },
    setListeners: function() {
      var self = this;
      self.$address.on('keyup',function(){
        window.$currentAddress = $(this); //This is clunky, but we're losing our closure with Google's callback
        self.getSuggestions( $(this).val() );
        self.clearPlace( $(this) );
      })

      self.$suggestions.on('click', 'li', function(){ self.selectSuggestion( $(this).text(), $(this).closest('.directions__waypoint').find('input') ) });

      self.$button.on('click',function(){
        self.getDirections();
        self.$element.addClass('loading');
      })
    },

    getSuggestions: function( string ){
      var self = this;
      if( string.length < 3 ){
        return false;
      }else{
        this.autocompleteService.getQueryPredictions( { 
          input: string,
          types: ['(cities)'],
          componentRestrictions: {country: 'CA'}
        }, self.displaySuggestions );
      }
    },

    displaySuggestions: function(predictions, status) {
      if (status != google.maps.places.PlacesServiceStatus.OK) {
        return;
      }

      var $suggestions = $(window.$currentAddress).closest('.directions__waypoint').find('.directions__suggestions');

      $suggestions.empty();

      predictions.forEach(function(prediction) {
        //Only include canadian suggestions
        if( prediction.description.includes("Canada") ){
          var suggestion = prediction.description.replace(", Canada", "");
          $suggestions.append('<li>' + suggestion + '</li>');
        }
      });
    },

    selectSuggestion: function( address, $element ) {
      $element.val( address );
      $element.closest('.directions__waypoint').find('.directions__suggestions').empty();
      this.setPlace( $element );
    },

    setPlace: function( $element ){
      if( $element.is('#ob-waypoint-start') ){
        this.departure_label = $element.val();
        this.departure = this.departure_label + ", Canada";
        this.$playlist__departure.text( this.departure_label );
      }else if( $element.is('#ob-waypoint-end') ){
        this.destination_label = $element.val();
        this.destination = this.destination_label + ", Canada";
        this.$playlist__destination.text( this.destination_label );
      }

      this.checkButton();
    },

    checkButton: function(){
      if( this.departure && this.destination ){
        this.enableButton();
      }else{
        this.disableButton();
      }
    },

    disableButton: function(){
      this.$button.addClass('button--inactive');
    },

    enableButton: function() {
      this.$button.removeClass('button--inactive');
    },

    clearPlace: function( $element ){
      if( $element.is('#ob-waypoint-start') ){
        this.departure = false;
      }else if( $element.is('#ob-waypoint-end') ){
        this.destination = false;
      }
    },

    getDirections: function() {
      var self = this;
      var request = {
        origin: self.departure,
        destination: self.destination,
        provideRouteAlternatives: true,
        travelMode: 'DRIVING',
        avoidTolls: true,
        region: 'CA'
      };

      self.directionsService.route(request, function(result, status) {
        if (status == 'OK') {
          
          self.$playlist.addClass('playlist--has-tracks');

          var route = result.routes[0].overview_path;
          var route_index = 0;
          
          //Loop through routes and find the first one that doesn't go through the US
          var i = 0;
          for( var current_route of result.routes ){
            if( self.entersUS( current_route.legs[0].steps ) == false ){
              route = current_route.overview_path;
              route_index = i;
              break;
            }
            i++;
          }

          self.directionsDisplay.setDirections(result);
          self.directionsDisplay.setRouteIndex(route_index);

          var paths = self.parsePaths( route );

          var data = {
            "title" : "wavway – " + self.departure_label + " to " + self.destination_label,
            "departure" : self.departure,
            "destination" : self.destination,
            "paths" : paths
          };

          if( !self.is_permalink ){
            self.getTracks( data );
          }

          setTimeout(function(){
            google.maps.event.trigger(self.$map, 'resize'); 
          },250)

        }
      });
    },

    entersUS: function( steps ){
      //Look for the route that doesn't contain the phrase "Now entering the United Stated of America" in the instructions
      var enters_us = false;
      for( var step of steps ){
        if( step.instructions.includes("United States")  ){
          enters_us = true;
        }
      }
      return enters_us;
    },

    parsePaths: function( paths ){
      var parsed_paths = new Array();
      for( let value of paths  ){
        parsed_paths.push({
          'latitude' : value.lat(),
          'longitude' : value.lng()
        });
      };
      return parsed_paths;
    },

    getTracks: function( data ){
      var self = this;
      var url = self.apiBase + 'playlist';
      data = JSON.stringify( data );

      $.ajax({
        method: 'POST',
        beforeSend: function ( xhr ) {
          xhr.setRequestHeader( 'X-WP-Nonce', self.nonce );
        },
        data: data,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        url: url,
      }).done(function( response ) {
        self.clearTracks();
        self.showTracks( response.songs );
        //self.pinTracks( response.songs );

        var playlist = response.playlist;
        if( playlist ){
          self.showPlaylist( playlist );
        }else{
          self.hidePlaylist();
        }

        var trip = response.trip;
        if( trip ){
          self.showShare( trip );
        }

        self.$element.removeClass('loading');

      });
    },

    showTracks: function( tracks ){
      var self = this;
      var i = 0;
      var track_html = "";
      for( let track of tracks  ){

                                      track_html = track_html + "<li class='playlist__track track'><input id='track--" + i + "' class='track__toggle' type='checkbox'>";
        if( track.song_name ){        track_html = track_html + "<span class='track__song'>" + track.song_name + "</span>"; }
        if( track.artist ){           track_html = track_html + "<span class='track__artist'>" + track.artist + "</span>"; }
        if( track.running_time ){     track_html = track_html + "<span class='track__length'>" + track.running_time + "</span>"; }
                                      track_html = track_html + "<label for='track--" + i + "' class='track__toggle--label'><span>Show Details</span></label>";                          
                                      track_html = track_html + "<div class='track__details'>";
        if( track.notes ){            track_html = track_html + "<p class='track__notes'>" + track.notes + "</p>"; }
        if( track.spotify_link ){     track_html = track_html + "<a href='" + track.spotify_link + "' class='button icon icon--spotify'>Open in Spotify</a>"; }
                                      track_html = track_html + "</div></li>";
        i++;
      
      }
      self.$trackList.append( track_html );
    },

    showPlaylist: function( playlist ){
      this.$playlist__link.attr("href", playlist).removeClass('playlist__link--inactive');
    },

    hidePlaylist: function(){
      this.$playlist__link.addClass('playlist__link--inactive');
    },

    showShare: function( trip ){
      var tweetText = encodeURIComponent( "Listen to my road trip with wavway | " + this.departure_label + " → " + this.destination_label );
      this.$share__link_facebook.attr('href', "https://www.facebook.com/sharer/sharer.php?u=" + trip);
      this.$share__link_twitter.attr('href', "https://twitter.com/intent/tweet?text=" + tweetText + "&url=" + trip);

      this.$playlist__links.removeClass('playlist__links--inactive');
    },

    pinTracks: function( tracks ){
      var self = this;
      var i = 0;

      for( let value of tracks  ){

        var contentString = '<div><strong>' + value.song_name + '</strong> ' + value.artist + '</div>';
      
        var latLng = new google.maps.LatLng( value.latitude, value.longitude );
        self.markers[i] = new google.maps.Marker({
          position: latLng,
          map: self.map,
          title: value.song_name
        });

        self.markers[i].infoWindow = new google.maps.InfoWindow({
          content: contentString
        });
        
        self.markers[i].addListener('click', function() {
          this.infoWindow.open( self.map, self.markers[i] );
        });

        i++;
      }
    },

    clearTracks: function(){
      var self = this;
      self.$trackList.empty();
      for( let marker of self.markers ){
        marker.setMap( null );
        marker.infoWindow.setMap( null );
      }

    },

    renderMap: function(){
      var self = this;

      self.mapCenter = new google.maps.LatLng( self.latitude, self.longitude );
      
      self.map = new google.maps.Map( document.getElementById('ob-map'), {
        zoom: 5,
        center: self.mapCenter,
        disableDefaultUI: true,
        streetViewControl: false,
        mapTypeControl: false,
        scrollwheel: false,
        styles: [{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"administrative","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#d2d2d2"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#d2d2d2"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit.station","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#dbdbdb"},{"visibility":"on"}]}]
      
      });

      self.directionsDisplay.setMap( self.map );

    },



  }

  $.fn[pluginName] = function(options) {
    var args = arguments;

    if (options === undefined || typeof options === 'object') {
      return this.each(function() {

        if (!$.data(this, 'plugin_' + pluginName)) {
          $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
        }
      });

    } else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {

      var returns;

      this.each(function() {
        var instance = $.data(this, 'plugin_' + pluginName);

        if (instance instanceof Plugin && typeof instance[options] === 'function') {

          returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
        }

        if (options === 'destroy') {
          $.data(this, 'plugin_' + pluginName, null);
        }
      });

      return returns !== undefined ? returns : this;
    }
  };

  $(document).ready(function(){
    $('#ob-wavway').obWavWay();
  });


}( jQuery, window, document, google, obMapMarker ) );